import { useHistory } from "react-router-dom";
import {
  Header,
  Section,
  StyledForm,
  SubHeader,
  TopSaveWrapper,
} from "./RoomForm.styles";
import { RadioList, TextInput } from "@milestone/component-library";
import { Formik, FormikHelpers } from "formik";
import { RoomFormType, RoomSchema, YesNo } from "./roomSchema";
import {
  BlueButton,
  ColumnContainer,
  OutlineButton,
  SaveButtonContainer,
} from "../../Admin.styles";
import { Office } from "../../../../services/api/types/Offices";

export enum RoomFormHeader {
  add = "Add Room",
  edit = "Edit Room",
}

export interface RoomFormProps {
  header: string;
  submitValues: (
    values: RoomFormType,
    actions: FormikHelpers<RoomFormType>
  ) => void;
  value?: RoomFormType;
  office: Office;
}

export const RoomForm: React.FC<RoomFormProps> = ({
  header,
  submitValues,
  value,
  office,
}) => {
  const roomData: RoomFormType = {
    roomName: value?.roomName || "",
    roomNumber: value?.roomNumber || 0,
    computerNumber: value?.computerNumber || "",
    computerUserName: value?.computerUserName || "",
    computerPassword: value?.computerPassword || "",
    hasAppleTv: value?.hasAppleTv || "",
    hasHdmi: value?.hasHdmi || "",
  };
  const history = useHistory();

  const navigateToEdit = () => {
    const currentLocation = history.location;
    currentLocation.pathname =
      currentLocation.pathname.split("/").slice(0, -2).join("/") + "/edit";
    history.push(currentLocation);
  };

  const handleCancel = () => {
    navigateToEdit();
  };

  const SaveButtons = (
    <SaveButtonContainer>
      <BlueButton type="submit">Save</BlueButton>
      <OutlineButton type="button" onClick={handleCancel}>
        Cancel
      </OutlineButton>
    </SaveButtonContainer>
  );

  return (
    <ColumnContainer>
      <Formik
        initialValues={roomData}
        validationSchema={RoomSchema}
        onSubmit={submitValues}
      >
        {() => (
          <StyledForm>
            <TopSaveWrapper>{SaveButtons}</TopSaveWrapper>
            <Header>{office?.name}</Header>
            <SubHeader>{office?.address}</SubHeader>
            <Section>
              <Header>{header}</Header>
              <TextInput name="roomName" label="Room Name" />
              <TextInput name="roomNumber" label="Room Number" type="number" />
              <TextInput name="computerNumber" label="Computer Number" />
              <TextInput name="computerUserName" label="Username" />
              <TextInput name="computerPassword" label="Password" />
              <RadioList
                label="Apple TV available"
                name="hasAppleTv"
                options={YesNo}
              />
              <RadioList
                label="HDMI availability"
                name="hasHdmi"
                options={YesNo}
              />
              {SaveButtons}
            </Section>
          </StyledForm>
        )}
      </Formik>
    </ColumnContainer>
  );
};
